module.exports = __webpack_public_path__ + "img/blog-6.be658bda.webp";